export enum FillinLimitType {
  single = 'single',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}

export namespace FillinLimitType {
  export const translateType = (type: FillinLimitType): string | null => {
    switch (type) {
      case FillinLimitType.single:
        return "Único"
      case FillinLimitType.daily:
        return "Diário";
      case FillinLimitType.weekly:
        return "Semanal";
      case FillinLimitType.monthly:
        return "Mensal";
      default: return null;
    };
  };

  export const fillinLimitTypeChoices: Array<{ id: string, name: string }> = Object.values(FillinLimitType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: FillinLimitType.translateType(type as FillinLimitType),
    } as { id: string, name: string }));
};
